import { Button } from '@portals-platform/ui';
import { Link } from '@tanstack/react-router';

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export function ErrorPage({ error, reset }: ErrorPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--color-background)] p-4">
      <h1 className="text-4xl font-bold text-[var(--color-foreground)]">Something went wrong</h1>
      <p className="max-w-md text-center text-[var(--color-muted-foreground)] text-sm">
        {error.message || 'An unexpected error occurred. Please try again.'}
      </p>
      <div className="flex gap-3">
        <Button variant="outline" onClick={reset}>
          Try again
        </Button>
        <Button asChild>
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </div>
  );
}
